import React from 'react';

function ContactForm({ item, className }) {
    const { id, fields = {} } = item;
    const previewFields = [
        {
            type: 'text',
            name: 'name',
            fieldType: 'name',
            component: 'input',
            className: 'form-control',
        },
        {
            type: 'email',
            name: 'email',
            fieldType: 'email',
            component: 'input',
            className: 'form-control',
        },
        {
            type: 'text',
            name: 'phone',
            fieldType: 'phone',
            component: 'input',
            className: 'form-control',
        },
        {
            type: 'text',
            name: 'subject',
            fieldType: 'subject',
            component: 'input',
            className: 'form-control',
        },
        {
            name: 'message',
            fieldType: 'message',
            component: 'textarea',
            className: 'form-control',
        },
        {
            type: 'button',
            name: 'button',
            fieldType: 'button',
            component: 'button',
        },
    ];

    const isEnabled = (data) => (data ? data._enabled : false);

    const mergedFields = previewFields.map((field) => {
        const data = fields[field.fieldType];
        return data ? { ...field, data } : field;
    });

    return (
        <form id={id} className={className}>
            <input type="hidden" name="formId" value={id} />
            {mergedFields.map((field, index) =>
                isEnabled(field.data) ? (
                    <div
                        key={index}
                        className={`form-group ${
                            field.fieldType === 'button' ? 'form-button' : ''
                        }`.trim()}
                    >
                        {field.data.label && <label>{field.data.label}</label>}
                        <RenderField field={field} />
                    </div>
                ) : null
            )}
        </form>
    );
}

function RenderField({ field }) {
    const { component, fieldType, data = {}, ...fieldAttr } = field;
    const { text } = data;
    return React.createElement(
        component,
        {
            ...fieldAttr,
            ...data.attr,
        },
        text
    );
}

export default ContactForm;
